/**
 * KHIYARSA (Phase 2): wires the cloud sync engine to the editor. The only
 * integration points in App.tsx are this hook, the notifySceneReady() call
 * after initializeScene resolves, and the <KhiyarsaCloudUI/> children.
 */
import { useEffect } from "react";

import type { ExcalidrawImperativeAPI } from "@excalidraw/excalidraw/types";

import { cloudSync } from "./sync";

export const useKhiyarsaCloud = (
  excalidrawAPI: ExcalidrawImperativeAPI | null,
) => {
  useEffect(() => {
    if (excalidrawAPI) {
      cloudSync.init(excalidrawAPI);
    }
  }, [excalidrawAPI]);
};

export const khiyarsaCloudSceneReady = () => cloudSync.notifySceneReady();
